const ICONS = {
  introduction: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" aria-hidden>
      <path d="M4 6h16M4 12h10M4 18h14" strokeLinecap="round" />
    </svg>
  ),
  specs: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" aria-hidden>
      <path d="M12 3v18M3 12h18" strokeLinecap="round" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  ),
  audience: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" aria-hidden>
      <circle cx="9" cy="8" r="3" />
      <circle cx="17" cy="10" r="2.5" />
      <path d="M3 20c0-3 2.5-5 6-5s6 2 6 5M13 20c0-2 1.5-3.5 4-3.5" strokeLinecap="round" />
    </svg>
  ),
  priceTier: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" aria-hidden>
      <path d="M12 3v18M7 8h6a3 3 0 010 6H9a3 3 0 000 6h8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
}

export function ArticleSectionIcon({ sectionKey }) {
  return (
    <span className="product-article-icon" aria-hidden>
      {ICONS[sectionKey] || ICONS.introduction}
    </span>
  )
}
